// src/plugins/sales-forecast/components/SquareFootRangeControl.tsx
import React from "react";
import {
  RangeSliderControl,
  RangeSliderControlProps,
} from "./RangeSliderControl";

export interface SquareFootRangeControlProps
  extends Pick<
    RangeSliderControlProps,
    "min" | "max" | "step" | "values" | "onChange"
  > {}

export const SquareFootRangeControl: React.FC<SquareFootRangeControlProps> = ({
  min,
  max,
  step,
  values,
  onChange,
}) => (
  <RangeSliderControl
    label="Square Footage"
    min={min}
    max={max}
    step={step}
    values={values}
    onChange={onChange}
    formatValue={(value: number) => value.toLocaleString()}
  />
);